import styled from 'styled-components';

import { ConnectionsIcon, GearIcon, LockIcon, NavOrganizationIcon, NavProfileIcon } from '../../../assets';
import { ChevronRightIcon } from '../../../assets';
import { Button, SecondaryButton } from '../../../components';
import Input from '../../../components/Input';
import { bottomNavHeight } from '../../../components/layout/BottomNav/BottomNav.styles';
import { headerHeight } from '../../../components/layout/Header/Header.styles';
import ZIndexLayers from '../../../services/ZIndexLayers';
import { ThemeProp } from '../../../theme/Themes';
import { Container } from '../../commons/SideBoxesPage/SideBoxesPage.styles';
import { MOBILE_TOP_MARGIN_ADJUSTMENT } from '../../layouts/AuthenticatedLayout/AuthenticatedLayout.styles';

export const AvatarContainer = styled.div`
  display: flex;
  gap: 1.5rem;
  align-items: center;

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    margin-bottom: 1rem;
  }
`;

export const AvatarInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const AvatarTitle = styled.div`
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.medium};
  font-size: ${(props: ThemeProp) => props.theme.fontSize.ml};
  line-height: ${(props: ThemeProp) => props.theme.lineHeight.s};
  color: ${(props: ThemeProp) => props.theme.colors.content.default};
  margin-bottom: 0.125rem;
`;

export const AvatarSubtitle = styled.div`
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.regular};
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
  line-height: 1.125rem;
  color: ${(props: ThemeProp) => props.theme.colors.content.subdued.high};
`;

export const LogoutMobileButton = styled.div`
  display: none;
  align-items: center;
  gap: 0.5rem;
  margin-top: 0.375rem;
  color: ${(props: ThemeProp) => props.theme.colors.system.error};
  font-size: ${(props: ThemeProp) => props.theme.fontVariants.desktop.body2.fontSize};
  line-height: ${(props: ThemeProp) => props.theme.fontVariants.desktop.body2.lineHeight};
  text-decoration: underline;
  text-underline-offset: 0.188rem;
  cursor: pointer;

  svg {
    stroke: ${(props: ThemeProp) => props.theme.colors.system.error};
  }

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    display: flex;
  }
`;

const LRContainer = styled.div`
  background: ${(props: ThemeProp) => props.theme.colors.layout.surface.default};
  box-shadow: ${(props: ThemeProp) => props.theme.shadows.box};
  border-radius: 0.5rem;

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.tablet}) {
    box-shadow: none;
  }
`;

export const LeftContainer = styled(LRContainer)`
  display: flex;
  flex-direction: column;
  padding: 1.5rem;
  padding-bottom: ${bottomNavHeight};
  min-width: 14.125rem;
  flex: 1;

  @media (min-width: ${(props: ThemeProp) => props.theme.breakpoints.desktop}) {
    min-width: 22.5rem !important;
    padding: 1.5rem 1rem 0.75rem 1rem !important;
    flex: 0;
  }
`;

const CommonButtonProps = `  
  height: 3rem;
  border-radius: 3.375rem;
`;

export const StyledButton = styled(Button)`
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.regular};
  font-size: ${(props: ThemeProp) => props.theme.fontSize.ml};
  line-height: ${(props: ThemeProp) => props.theme.lineHeight.xs};
  padding: 0.813rem 1.25rem;

  ${CommonButtonProps}

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.tablet}) {
    width: 100% !important;
  }

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    width: 100%;
  }
`;

export const StyledSecondaryButton = styled(SecondaryButton)`
  ${CommonButtonProps}
  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.tablet}) {
    width: 50% !important;
  }
`;

const buttonContainerHeight = '6.626rem';

export const ButtonsContainer = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 0.5rem;
  height: ${buttonContainerHeight};
  justify-content: flex-end;
  width: 100%;
  height: auto;
  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    margin-top: 1.5rem;
    position: fixed;
    bottom: 0px;
    left: 0px;
    padding: 24px 24px 34px 24px;
    background: ${(props) => props.theme.colors.greyscale.c900};
    height: ${buttonContainerHeight};
  }
`;

export const StyledInput = styled(Input)`
  .nextui-input {
    color: ${(props: ThemeProp) => props.theme.colors.content.subdued.high};
  }

  .nextui-input:focus {
    color: ${(props: ThemeProp) => props.theme.colors.content.default};
  }
`;

export const NameInputs = styled.div`
  display: flex;
  flex: 1;
  gap: 1rem;

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.tablet}) {
    flex-direction: column;
    gap: 0rem;
  }
`;

export const StyledPassword = styled(Input.Password)`
  height: 2.875rem !important;
`;

export const NavigationContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 1.5rem;
  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    display: none;
  }
`;

export const NavigationMobileContainer = styled.div`
  flex-direction: column;
  display: none;

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    display: flex;
    flex: 1;
  }
`;

export const StyledGearIcon = styled(GearIcon).attrs((props: ThemeProp) => ({
  color: props.theme.colors.black,
}))``;

export const MobileSectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
`;

export const MobileSectionTitle = styled.div`
  font-size: 1.25rem;
  line-height: 1.75rem;
  font-weight: ${(props) => props.theme.fontWeight.medium};
  color: ${(props) => props.theme.colors.primary.c050};
  display: flex;
  height: 3rem;
  align-items: center;

  @media (min-width: ${(props: ThemeProp) => props.theme.breakpoints.tablet}) {
    display: none;
  }
`;

export const RightContainer = styled(LRContainer)`
  margin-top: 0px;

  @media (min-width: ${(props) => props.theme.breakpoints.desktop}) {
    min-width: 43rem !important;
    padding: 2rem 3rem 2.5rem 3rem !important;
  }
  @media (min-width: ${(props) => props.theme.breakpoints.tablet}) {
    padding: 2rem 2.375rem;
    min-width: 24.375rem;
  }

  @media (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    margin-top: 0;
    padding: 1.5rem 1rem 1rem 1rem;
    height: fit-content;
    width: 100%;
    box-shadow: ${(props: ThemeProp) => props.theme.shadows.box};
  }
`;

export const FullScreenMobileView = styled.div`
  display: none;
  margin-top: 0;
  padding: 1.5rem 1rem 1.5rem 1rem;
  height: calc(100vh - ${buttonContainerHeight} - ${headerHeight});
  width: 100%;
  position: fixed;
  top: ${`calc(${headerHeight} + ${MOBILE_TOP_MARGIN_ADJUSTMENT})`};
  right: 0px;
  background: ${(props: ThemeProp) => props.theme.colors.primary.c900};
  overflow-y: auto;
  z-index: ${ZIndexLayers.fullScreenOverlay};

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    display: flex;
  }
`;

export const StyledChevronRightIcon = styled(ChevronRightIcon)`
  margin-left: auto;
`;

export const LogoutItem = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  cursor: pointer;
  border-radius: 4px;
  font-weight: ${(props: ThemeProp) => props.theme.fontWeight.regular};
  font-size: ${(props: ThemeProp) => props.theme.fontSize.s};
  line-height: ${(props: ThemeProp) => props.theme.lineHeight.m};
  padding: 1rem 0.875rem;
  color: ${(props: ThemeProp) => props.theme.colors.content.default};

  svg {
    path {
      stroke: ${(props: ThemeProp) => props.theme.colors.content.default};
    }
  }

  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    font-weight: ${(props: ThemeProp) => props.theme.fontWeight.semibold};
    font-size: ${(props) => props.theme.fontSize.ml};
    line-height: ${(props) => props.theme.lineHeight.xs};
    padding: 1rem 0 2rem 0;

    svg {
      height: 1.25rem;
      width: 1.25rem;
    }
  }
`;

export const StyledNavProfileIcon = styled(NavProfileIcon)`
  height: 1.25rem;
  width: 1.25rem;

  @media (max-width: ${(props) => props.theme.breakpoints.mobile}) {
    height: 1.5rem;
    width: 1.5rem;
  }
`;

export const LogoutModalContainer = styled.div`
  padding: 0 0.5rem;
  color: ${(props: ThemeProp) => props.theme.colors.greyscale.c100};
  text-align: left;
`;

export const StyledContainer = styled(Container)`
  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    padding: 0;
    background: ${(props: ThemeProp) => props.theme.colors.layout.surface.default};
  }
`;

export const StyledNavOrganization = styled(NavOrganizationIcon)`
  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    height: 1.5rem;
    width: 1.5rem;
    path {
      stroke-width: 1.75px;
    }
  }
`;

export const StyledNavConnections = styled(ConnectionsIcon)`
  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    height: 1.5rem;
    width: 1.5rem;
  }
`;

export const StyledLockIcon = styled(LockIcon)`
  @media (max-width: ${(props: ThemeProp) => props.theme.breakpoints.mobile}) {
    height: 1.5rem;
    width: 1.5rem;
  }
`;
